// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Material } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetMaterial(): (id: string) => Promise<Material> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).material.getMaterial({ id }),
    [getAPI]
  );
}
